import PopoverDropdown from "../../../../elements/PopoverDropdown";
import { SketchPicker } from "react-color";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { setThemeValue } from "../../../../../redux/slice/themeSlice";
import { rgba } from "../../../../../helpers";

const PreviewPanelHeaderTool = ({ element }) => {
  const dispatch = useDispatch();
  const { theme, selectedElement } = useSelector((state) => state?.themeProvider);
  return (
    <div className="space-y-4">
      <PopoverDropdown
        buttonLabel={
          <div className="flex items-center space-x-2">
            {theme?.[element]?.backgroundColor && (
              <span
                className="w-6 h-6 flex rounded"
                style={{
                  backgroundColor: rgba(theme?.[element]?.backgroundColor),
                }}></span>
            )}
            <span>Select colour</span>
          </div>
        }
        buttonClass="w-full bg-gray-100 border border-transparent hover:border hover:border-gray-400 hover:bg-gray-200 text-start text-gray-500 text-sm"
        contentClass="border-0 p-0 !min-w-fit bg-transparent">
        <SketchPicker
          className="!shadow-none !border-0"
          color={theme?.[element]?.backgroundColor}
          onChange={(e) => {
            dispatch(setThemeValue({ [element]: { backgroundColor: e.rgb } }));
          }}
        />
      </PopoverDropdown>
    </div>
  );
};

export default PreviewPanelHeaderTool;
